import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import AppContext from "../../context/AppContext";
import Glyphicon from "../Glyphicon";
import { getInfoObject } from "./functions";
import InfoWindowNajczestszeTrasy from "../InfoWindowNajczestszeTrasy";
import InfoWindowOpis from "../InfoWindowOpis";
import InfoWindowSpanie from "../InfoWindowSpanie";
import InfoWindowGalerie from "../InfoWindowGalerie";
import InfoWindowPrzewodniki from "../InfoWindowPrzewodniki";
import InfoWindowListaWyjazdow from "../InfoWindowListaWyjazdow";

class InfoWindow extends PureComponent {
  static contextType = AppContext;

  handleClick = () => {
    const { hideInfoWindow } = this.context;
    hideInfoWindow();
  };

  render() {
    const { infoWindow, airports, places } = this.context;
    const infoObject = getInfoObject(infoWindow, airports, places);
    return (
      <section className="InfoWindow">
        <div className="InfoWindow_container">
          <div className="InfoWindow_menu">
            <span className="InfoWindow_menuItem">
              <button className="InfoWindow_menuButton">
                <Glyphicon
                  className="InfoWindow_menuIcon"
                  icon="info_outline"
                />
                {infoObject.name}
              </button>
            </span>
          </div>
          <div className="InfoWindow_description">
            <InfoWindowOpis description={infoObject.description} />
            {infoWindow.type === "airport" && (
              <InfoWindowNajczestszeTrasy id={infoWindow.id} />
            )}
            {infoWindow.type === "airport" && (
              <InfoWindowSpanie
                id={infoWindow.id}
                sleepingGuide={infoObject.sleepingGuide}
              />
            )}
            <InfoWindowGalerie galleries={infoObject.galleries} />
            <InfoWindowPrzewodniki
              guides={infoObject.guides}
              name={infoObject.name}
            />
            {infoWindow.type === "place" && (
              <InfoWindowListaWyjazdow trips={infoObject.trips} />
            )}
          </div>
        </div>
        <button
          className="InfoWindow_closeButton"
          title="Zamknij okno"
          onClick={this.handleClick}
        >
          <Glyphicon icon="close" />
        </button>
      </section>
    );
  }
}

export default InfoWindow;
